/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_AspectInputs */

const cs_social_templates_aspect = /** @type {(inputs: Social_Templates_AspectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poměr stran`)
};

const en_social_templates_aspect = /** @type {(inputs: Social_Templates_AspectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect ratio`)
};

/**
* | output |
* | --- |
* | "Aspect ratio" |
*
* @param {Social_Templates_AspectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_aspect = /** @type {((inputs?: Social_Templates_AspectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_AspectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_aspect(inputs)
	return cs_social_templates_aspect(inputs)
});